/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';

export class GetProductBenefitsEnhancedContentInput extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    public masterProductID: string = '';
    constructor( masterProductID:string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'productBenefitsEnhancedContentCache', cacheKey: 'productBenefitsEnhancedContentCache' });
        this.masterProductID = masterProductID;
    }
    public getCacheKey = () => `productBenefitsEnhancedContentCache`;
    public getCacheObjectType = () => 'productBenefitsEnhancedContentCache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}
// tslint:disable: no-any
async function getEnhancedContentAction(input: GetProductBenefitsEnhancedContentInput, ctx: Msdyn365.IActionContext): Promise<any> {
    const jsonUrlFromGlobals = ctx.requestContext.app.config.productBenefitsEnhancedContentUrl;
    const masterProductid = input.masterProductID;
    const jsonUrl = jsonUrlFromGlobals || '';
    try {
        const res = await Msdyn365.sendRequest<any>(jsonUrl, 'get');
        if (res && masterProductid) {
            const productBenefitData = res.data && res.data[masterProductid];
            return productBenefitData;
        }
    }
    catch (error) {
        console.log('error', error);
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    id: 'productBenefitsEnhancedContent',
    action: <Msdyn365.IAction<any>>getEnhancedContentAction
});